import PipelineAPI from '../../api/pipeline';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
  },
};

const getters = {
  getPipelines: $state => $state.records,
  getDefaultPipeline: $state =>
    $state.records.find(p => p.is_default) || $state.records[0],
  getUIFlags: $state => $state.uiFlags,
  getPipelineById: $state => id =>
    $state.records.find(p => p.id === Number(id)),
};

const mutations = {
  SET_PIPELINES($state, pipelines) {
    $state.records = pipelines;
  },
  ADD_PIPELINE($state, pipeline) {
    $state.records.push(pipeline);
  },
  UPDATE_PIPELINE($state, pipeline) {
    const index = $state.records.findIndex(p => p.id === pipeline.id);
    if (index !== -1) $state.records.splice(index, 1, pipeline);
  },
  DELETE_PIPELINE($state, id) {
    $state.records = $state.records.filter(p => p.id !== id);
  },
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await PipelineAPI.get();
      commit('SET_PIPELINES', data.payload);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit }, { withDefaults = true, ...pipelineData }) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = withDefaults
        ? await PipelineAPI.createWithDefaults(pipelineData)
        : await PipelineAPI.createEmpty(pipelineData);
      commit('ADD_PIPELINE', data);
      return data;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, ...updateData }) {
    try {
      const { data } = await PipelineAPI.update(id, updateData);
      commit('UPDATE_PIPELINE', data);
    } catch (error) {
      throw error;
    }
  },

  async delete({ commit }, id) {
    try {
      await PipelineAPI.delete(id);
      commit('DELETE_PIPELINE', id);
    } catch (error) {
      throw error;
    }
  },
};

export default { namespaced: true, state, getters, mutations, actions };
